export const CGU_VERSION = "v0.4";
export const CGU_DERNIERE_MISE_A_JOUR = "20 janvier 2025";
